export enum CallCause {
  UnknownCause = 0,
  UnallocatedNumber = 1,
  CallRejected = 2,
  NumberChanged = 3,
  DestinationOutOfOrder = 4,
  AddressIncomplete = 5,
  MobileSubscriberNotReachable = 6,
  Congestion = 7,
  SendSpecialInformationTone = 8,
  Busy = 9,
  NoReply = 10,
  Abandon = 11,
  OtherCause = 12,
  Answered = 100,
  AAbandon = 101,
  NetRedirect = 102,
  Error = 103,
  Kickout = 104,
  Click2DialNoAnswer = 105,
  ManualRejected = 106,
  Transfer = 107,
  TransferSupervised = 108,
  Captured = 200
}


export class CallCauseUtil {
  static getCallCauseString(causeCode: number): string {
    switch (causeCode) {
      case CallCause.AAbandon:
        return 'call_cause.aabandon';
      case CallCause.Abandon:
        return 'call_cause.abandon';
      case CallCause.AddressIncomplete:
        return 'call_cause.address_incomplete';
      case CallCause.Answered:
        return 'call_cause.answered';
      case CallCause.Busy:
        return 'call_cause.busy';
      case CallCause.CallRejected:
        return 'call_cause.rejected';
      case CallCause.Captured:
        return 'call_cause.captured';
      case CallCause.Click2DialNoAnswer:
        return 'call_cause.c2cnoanswer';
      case CallCause.Congestion:
        return 'call_cause.congestion';
      case CallCause.DestinationOutOfOrder:
        return 'call_cause.dest_out';
      case CallCause.Error:
        return 'call_cause.error';
      case CallCause.Kickout:
        return 'call_cause.kickout';
      case CallCause.ManualRejected:
        return 'call_cause.manual_rejected';
      case CallCause.MobileSubscriberNotReachable:
        return 'call_cause.not_reachable';
      case CallCause.NetRedirect:
        return 'call_cause.net_redir';
      case CallCause.NoReply:
        return 'call_cause.noreply';
      case CallCause.NumberChanged:
        return 'call_cause.number_changed';
      case CallCause.OtherCause:
        return 'call_cause.other_cause';
      case CallCause.SendSpecialInformationTone:
        return 'call_cause.special_tone';
      case CallCause.Transfer:
        return 'call_cause.transfer';
      case CallCause.TransferSupervised:
        return 'call_cause.transfer_super';
      case CallCause.UnallocatedNumber:
        return 'call_cause.unallocated';
      case CallCause.UnknownCause:
        return 'call_cause.unknown';
      default:
        return 'UnknownCause ' + causeCode;
    }
  }

  static isAAbandon(cause: number): boolean {
    return cause === CallCause.AAbandon;
  }

  static isCallAnswered(cause: number): boolean {
    return cause === CallCause.Answered;
  }

  static isCallMissed(cause: number): boolean {
    return cause === CallCause.NoReply || cause === CallCause.ManualRejected
      || cause === CallCause.CallRejected || cause === CallCause.Abandon || cause === CallCause.AAbandon;
  }
}
